import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const Person2StateFalseNotiFalseIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "Person2StateFalseNotiFalseIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M12 11.9673C9.20424 11.9673 6.92924 9.73136 6.92924 6.98314C6.92924 4.23591 9.20424 2 12 2C14.7958 2 17.0703 4.23591 17.0703 6.98314C17.0703 9.73136 14.7958 11.9673 12 11.9673ZM12 4.44044C10.5731 4.44044 9.41234 5.58123 9.41234 6.98314C9.41234 8.38604 10.5731 9.52683 12 9.52683C13.4269 9.52683 14.5872 8.38604 14.5872 6.98314C14.5872 5.58123 13.4269 4.44044 12 4.44044Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.7584 22C19.073 22 18.5169 21.4539 18.5169 20.7798V17.8827C18.5169 16.8174 17.6355 15.9516 16.5515 15.9516H7.44797C6.36451 15.9516 5.48311 16.8174 5.48311 17.8827V20.7798C5.48311 21.4539 4.92699 22 4.24156 22C3.55612 22 3 21.4539 3 20.7798V17.8827C3 15.472 4.99568 13.5112 7.44797 13.5112H16.5515C19.0043 13.5112 21 15.472 21 17.8827V20.7798C21 21.4539 20.4439 22 19.7584 22Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default Person2StateFalseNotiFalseIcon;
